import type { RefObject } from 'react'
import { getLineBounds } from '../utils'
import { matchList } from '../listUtils'
import { clearLineAction } from './clearLineAction'

export const clearListItemAction = (
  textareaRef: RefObject<HTMLTextAreaElement>,
  value: string,
  onChange: (val: string) => void,
): boolean => {
  const el = textareaRef.current
  if (!el) return false

  const s = el.selectionStart ?? 0
  const e = el.selectionEnd ?? s

  const startInfo = getLineBounds(value, s)
  const endIndex = e > s ? e - 1 : s
  const endInfo = getLineBounds(value, endIndex)

  const m = matchList(startInfo.line)
  if (!m) return false

  const markerLen = (m[1] || '').length + (m[2] || '').length
  const sRel = s - startInfo.lineStart
  const eRel = e - endInfo.lineStart

  const beforeSelOnStart = startInfo.line.slice(
    markerLen,
    Math.max(markerLen, sRel),
  )
  if (!/^\s*$/.test(beforeSelOnStart)) return false

  const afterSelOnEnd = endInfo.line.slice(Math.min(eRel, endInfo.line.length))
  if (!/^\s*$/.test(afterSelOnEnd)) return false

  return clearLineAction(textareaRef, value, onChange)
}
